import React from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

interface HeaderProps {
  menuOpen: boolean;
  setMenuOpen: (open: boolean) => void;
}

const Header: React.FC<HeaderProps> = ({ menuOpen, setMenuOpen }) => {
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <header className={`header ${menuOpen ? 'menu-open' : ''}`}>
        <div className="header__container">
          <Link to="/" className="header__logo">
              <img src="/images/Logo.png" alt="Stage Door Weddings Logo" className="header__logo-img" />
            </Link>

          <button
            className={`header__burger ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>

      <aside className={`side-menu ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className="side-menu__logo" onClick={closeMenu}>
          <img src="/images/Logo.png" alt="Stage Door Weddings Logo" />
        </Link>
        
        <nav className="side-menu__nav">
          <h3 className="side-menu__title">MENU</h3>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
          <Link to="/" onClick={closeMenu}>Films</Link>
          <Link to="/team" onClick={closeMenu}>About Us</Link>
          <Link to="/pricing" onClick={closeMenu}>Pricing & Packages</Link>
          <Link to="/portfolio" onClick={closeMenu}>Testimonials</Link>
          <Link to="/weddings" onClick={closeMenu}>Wedding Videography</Link>
          <Link to="/blog" onClick={closeMenu}>Blog</Link>
        </nav>
      </aside>

      {menuOpen && <div className="menu-backdrop" onClick={closeMenu}></div>}
    </>
  );
};

export default Header;
